import { useEffect, useState } from "react"
import { Modal, ModalId, useUIActions, useUIState } from "../../../ui"
import { Data2 } from "../../../data-types"
import { AddressFormLoader } from "./loader"

type Props = {
    addressData?: Data2
    onSubmit: (data: Data2) => void
}

export const AddressFormModal = (props: Props) => {
    const { addressData, onSubmit } = props
    
    const [key, setKey] = useState(0)
    
    const { openedModal } = useUIState()
    
    const { closeModal } = useUIActions()

    useEffect(() => setKey(key + 1), [openedModal])

    const handleSubmit = (data: Data2) => {
        onSubmit(data)
        closeModal(ModalId.ADDRESS_FORM)
    }

    const onCancel = () => closeModal(ModalId.ADDRESS_FORM)
    
    return (
        <Modal
            modalId={ModalId.ADDRESS_FORM}
            title="Agregar Dirección"
            actions={[]}
            widthSize="m"
        >
            {openedModal === ModalId.ADDRESS_FORM ? (
                <AddressFormLoader
                    key={key}
                    addressData={addressData}
                    onSubmit={handleSubmit}
                    onCancel={onCancel}
                />
            ) : <></>}
        </Modal>
    )
}
